import { createSelector } from 'reselect';

import { INote, INoteShared, IQuestion, isNote, isSharedNote } from '../../types';
import { notesEditor, notesResource } from './resource';

import { notesCurrentPageSelector, notesSharedCurrentPageSelector, questionsCurrentPageSelector } from '../pageFilter/selectors';
import { notesSharedEditor, notesSharedResource } from '../noteshared/resource';

export const pageNoteSelector = notesCurrentPageSelector;
export const pageSharedNoteSelector = notesSharedCurrentPageSelector;
export const pageQuestionSelector = questionsCurrentPageSelector;
export const nextNoteSelector = createSelector(
    pageNoteSelector,
    pageSharedNoteSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, itemsshared, note, sharednote) => {
        return !!isSharedNote(sharednote) ? getNextNote(items.concat(itemsshared), sharednote): getNextNote(items.concat(itemsshared), note);},
);
export const prevNoteSelector = createSelector(
    pageNoteSelector,
    pageSharedNoteSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, itemsshared, note, sharednote) => !!isSharedNote(sharednote) ? getPrevNote(items.concat(itemsshared), sharednote): getPrevNote(items.concat(itemsshared), note),
);
export const indexNoteSelector = createSelector(
    pageNoteSelector,
    pageSharedNoteSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, itemsshared, note, sharednote) => !!isSharedNote(sharednote) ? getNoteIndex(items.concat(itemsshared), sharednote): getNoteIndex(items.concat(itemsshared), note),
);

export const nextQuestionSelector = createSelector(
    pageQuestionSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, note, sharednote) => !!isSharedNote(sharednote) ? getNextNote(items, sharednote): getNextNote(items, note),
);

export const prevQuestionSelector = createSelector(
    pageQuestionSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, note, sharednote) => !!isSharedNote(sharednote) ? getPrevNote(items, sharednote): getPrevNote(items, note),
);
export const indexQuestionSelector = createSelector(
    pageQuestionSelector,
    notesEditor.selectors.item, 
    notesSharedEditor.selectors.item,
    (items, note, sharednote) => !!isSharedNote(sharednote) ? getNoteIndex(items, sharednote): getNoteIndex(items, note),
);

function getNoteIndex(items: (INote|INoteShared|IQuestion)[], note: (INote|INoteShared)) {
    return items.reduce((idx, curItem, curIdx) => {
                if (!!isSharedNote(note) && !!isSharedNote(curItem)) {
                    return notesSharedResource.hasSameId(note, curItem) ? curIdx : idx; 
                } else if (!!isNote(note) && !!isNote(curItem)) {
                    return notesResource.hasSameId(note, curItem) ? curIdx : idx;
                } else return -1;
            }
         , -1);
}
function getNextNote(items: (INote|INoteShared|IQuestion)[], note: (INote|INoteShared)) {
    return items.qRotate(-1)[getNoteIndex(items, note)];
}
function getPrevNote(items: (INote|INoteShared)[], note: (INote|INoteShared)) {
    return items.qRotate(+1)[getNoteIndex(items, note)];
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/sortVisual.tsx